/**
 * SIMPLE IS — 店舗動画カード（JSON）とハッシュタグ投稿（sb-style / coordinate API）
 *
 * webpack の glob('./src/**\/*.js') で bundle.js に入る（全ページ共通）。
 * 対象要素が無いページでは何もしない。Vue2 + axios は HTML の <head> で CDN 読み込み済み。
 */

// ▼公開時はここだけ差し替える -------------------------------------------
// 本番タグ: 'Simple is…_LEPSIM'（… は三点リーダ U+2026。半角ドット3つではない）
var SIMPLE_IS_TAG = 'Simple is…_LEPSIM';
// ----------------------------------------------------------------------

var SIMPLE_IS_LABEL = '0000000028'; // LEPSIM のブランドID
var SIMPLE_IS_COUNT = 6; // 取得件数（カンプが3列×2行のため6件）
var SIMPLE_IS_API = 'https://sb-api.dot-st.com/jp/ja/v1/coordinate?merchant_id=75d19a0d30140e4e3109f8a29f61214c';

// 店舗カードのデータ。公開は JSON の publish が制御するのでHTMLは触らない
// 月次でJSONを差し替えたら ?の値を更新する（CloudFrontに旧JSONが残るため）
var SIMPLE_IS_JSON = '/assets/data/simple_is.json?260901';
var SIMPLE_IS_COLS = 4; // PCのグリッド列数。最終行の端数を空セルで埋めるのに使う
var SIMPLE_IS_PAGE_SIZE = 12; // 1ページあたりの表示枚数（PC4列×3行）
var SIMPLE_IS_HEADER_OFFSET = 71; // 固定ヘッダーの高さ（control.js の HEADER_OFFSET と同値）
var SIMPLE_IS_MOVIE_DIR = '/assets/movie/simple_is/';

// 都道府県 → バッジの地域クラス（色は style.scss の --地域名 側で定義）
// 沖縄はSCSSに専用色が無いため kyushu に寄せている
var SIMPLE_IS_REGIONS = {
	hokkaido: ['北海道'],
	tohoku: ['青森', '岩手', '宮城', '秋田', '山形', '福島'],
	kanto: ['茨城', '栃木', '群馬', '埼玉', '千葉', '東京', '神奈川'],
	chubu: ['新潟', '富山', '石川', '福井', '山梨', '長野', '岐阜', '静岡', '愛知'],
	kansai: ['三重', '滋賀', '京都', '大阪', '兵庫', '奈良', '和歌山'],
	chugoku: ['鳥取', '島根', '岡山', '広島', '山口'],
	shikoku: ['徳島', '香川', '愛媛', '高知'],
	kyushu: ['福岡', '佐賀', '長崎', '熊本', '大分', '宮崎', '鹿児島', '沖縄'],
};

// 絞り込みボタンのラベル（キーは SIMPLE_IS_REGIONS と同じ）
var SIMPLE_IS_AREA_LABELS = {
	hokkaido: '北海道',
	tohoku: '東北',
	kanto: '関東',
	chubu: '中部',
	kansai: '関西',
	chugoku: '中国',
	shikoku: '四国',
	kyushu: '九州',
};

// 都道府県 → URL用ローマ字。?area=miyagi のように県単位でも絞り込めるようにするため
// （日本語のままURLに載せると %E5%AE%AE%E5%9F%8E になって読めなくなる）
var SIMPLE_IS_PREF_ROMAJI = {
	北海道: 'hokkaido', 青森: 'aomori', 岩手: 'iwate', 宮城: 'miyagi', 秋田: 'akita', 山形: 'yamagata', 福島: 'fukushima',
	茨城: 'ibaraki', 栃木: 'tochigi', 群馬: 'gunma', 埼玉: 'saitama', 千葉: 'chiba', 東京: 'tokyo', 神奈川: 'kanagawa',
	新潟: 'niigata', 富山: 'toyama', 石川: 'ishikawa', 福井: 'fukui', 山梨: 'yamanashi', 長野: 'nagano', 岐阜: 'gifu',
	静岡: 'shizuoka', 愛知: 'aichi', 三重: 'mie', 滋賀: 'shiga', 京都: 'kyoto', 大阪: 'osaka', 兵庫: 'hyogo',
	奈良: 'nara', 和歌山: 'wakayama', 鳥取: 'tottori', 島根: 'shimane', 岡山: 'okayama', 広島: 'hiroshima', 山口: 'yamaguchi',
	徳島: 'tokushima', 香川: 'kagawa', 愛媛: 'ehime', 高知: 'kochi', 福岡: 'fukuoka', 佐賀: 'saga', 長崎: 'nagasaki',
	熊本: 'kumamoto', 大分: 'oita', 宮崎: 'miyazaki', 鹿児島: 'kagoshima', 沖縄: 'okinawa',
};

var SIMPLE_IS_PREF_REGION = (function () {
	var map = {};
	Object.keys(SIMPLE_IS_REGIONS).forEach(function (region) {
		SIMPLE_IS_REGIONS[region].forEach(function (pref) {
			map[pref] = region;
		});
	});
	return map;
})();

// 「宮城県」→「宮城」のように接尾辞を落とす。ただし先にマップ照合すること
// （単純に末尾を削ると「北海道」→「北海」、「京都」→「京」になって引けなくなる）
function simpleIsNormalizePref(pref) {
	var s = String(pref || '');
	if (SIMPLE_IS_PREF_REGION[s]) return s;
	return s.replace(/[都道府県]$/, '');
}

function simpleIsRegion(pref) {
	return SIMPLE_IS_PREF_REGION[simpleIsNormalizePref(pref)] || 'kanto';
}

// area は地域キー（tohoku）と都道府県キー（miyagi）の両方を受ける
function simpleIsMatchArea(item, area) {
	if (!area || area === 'all') return true;
	if (simpleIsRegion(item.pref) === area) return true;
	return SIMPLE_IS_PREF_ROMAJI[simpleIsNormalizePref(item.pref)] === area;
}

function simpleIsEscape(str) {
	if (!str) return '';
	return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// ─── 公開制御（simple_is.json の publish フィールド）───
//   "publish": true               → 表示（フィールド自体を書かなくても同じ）
//   "publish": false              → 非表示
//   "publish": "2026-07-27 00:00" → その時刻を過ぎたら表示
// 判定は閲覧者の端末の時計で行う（サーバー時刻ではないので数分のズレは出る）
// 確認用プレビュー（2026-08-27追加）。
//   URLに ?preview=1 を付けると **publish 日時を無視して未来分も表示**する。
//   本番URLに ?preview=1 を付けない限り効かないので通常運用には影響しない。
//   ※ 動画が無い店舗（movie未設定）は preview でも出さない＝壊れたカードは絶対に出さない。
function simpleIsPreview() {
	try {
		return /[?&]preview=1(&|$)/.test(window.location.search);
	} catch (e) {
		return false;
	}
}

function simpleIsPublished(item) {
	if (simpleIsPreview()) return true;
	var publish = item.publish;
	if (publish === undefined || publish === null || publish === true) return true;
	if (publish === false) return false;
	// new Date('2026-07-27 00:00') はブラウザによって NaN になるため自前で分解して組み立てる
	var m = String(publish).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
	// 書式ミスは非表示に倒す。表示に倒すとタイポに気付かないまま解禁前に出てしまうため
	if (!m) {
		console.warn('publish の書式が不正なので非表示にしました:', item.code, publish);
		return false;
	}
	return Date.now() >= new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]).getTime();
}

// 配信スケジュールだけ先に入れてある店舗は、素材が揃うまで publish 日時が来ても出さない
// （動画・ポスターが無いカードや、略称のままの店舗名が公開されるのを防ぐ）
//
// 2026-08-27 改訂: 判定に "movie" を追加した。
//   店名・都道府県・スタッフ（スタボID・インスタ）は**動画より先に届く**ため、
//   pref+staff だけを条件にすると「情報はあるが mp4 が無い」状態で
//   カードが出て動画が再生できない（＝壊れる）。
//   そこで **mp4/jpg を dist/assets/movie/simple_is/ に置いたら `"movie": true` を立てる**運用にし、
//   情報だけ先に全部流し込んでおける（＝動画が来た瞬間にフラグ1つで公開できる）ようにした。
function simpleIsReady(item) {
	return !!(item.pref && item.staff && item.staff.length && item.movie === true);
}

// 公開日（publish）を「M月D日 UPDATE」の控えめな表記にする。
// publish が true/false/未設定（＝日時指定なし）の店舗では何も出さない。
function simpleIsUpdatedHtml(item) {
	var publish = item.publish;
	if (typeof publish !== 'string') return '';
	var m = publish.match(/^(\d{4})-(\d{2})-(\d{2})/);
	if (!m) return '';
	var label = m[1] + '.' + m[2] + '.' + m[3];
	return (
		'<p class="simple-is__movie-updated"><time datetime="' +
		m[1] + '-' + m[2] + '-' + m[3] +
		'">' + label + '</time> UPDATE</p>'
	);
}

function simpleIsSnsHtml(staff) {
	var links = [];
	if (staff.sb) {
		links.push(
			'<li><a href="https://www.dot-st.com/cp/sb-staff-detail/?user_id=' +
				simpleIsEscape(staff.sb) +
				'" class="over" target="_blank" rel="noopener" title="STAFF BOARD"><img src="/assets/images/simple_is/ico_sb.svg" alt="STAFF BOARD" /></a></li>'
		);
	}
	if (staff.ig) {
		links.push(
			'<li><a href="https://www.instagram.com/' +
				simpleIsEscape(staff.ig) +
				'" class="over" target="_blank" rel="noopener" title="Instagram"><i class="fab fa-instagram"></i></a></li>'
		);
	}
	// 持っていないSNSは出さない。両方無いスタッフはリスト自体を出さない
	if (!links.length) return '';
	return '<ul class="simple-is__movie-staff-sns">' + links.join('') + '</ul>';
}

function simpleIsStaffHtml(staff) {
	return (staff || [])
		.map(function (s) {
			return (
				'<li class="simple-is__movie-staff-item">' +
				'<p class="simple-is__movie-staff-name">' +
				simpleIsEscape(s.name) +
				'</p>' +
				simpleIsSnsHtml(s) +
				'</li>'
			);
		})
		.join('');
}

function simpleIsCardHtml(item) {
	var code = simpleIsEscape(item.code);
	return (
		'<li class="simple-is__movie-card">' +
		'<div class="simple-is__movie-video anim fadeInUp">' +
		'<video src="' +
		SIMPLE_IS_MOVIE_DIR +
		code +
		'.mp4" playsinline controls controlsList="nodownload" disablePictureInPicture poster="' +
		SIMPLE_IS_MOVIE_DIR +
		code +
		'.jpg" preload="none"></video>' +
		'<button class="simple-is__movie-play" type="button" aria-label="動画を再生"></button>' +
		'</div>' +
		simpleIsUpdatedHtml(item) +
		'<div class="simple-is__movie-shop anim fadeInUp">' +
		'<h3 class="simple-is__movie-ttl en-pd">SHOP</h3>' +
		'<p class="simple-is__movie-shop-name"><a href="https://www.dot-st.com/cp/sb-shop-staff/?shop_code=' +
		code +
		'" class="over" target="_blank" rel="noopener">' +
		simpleIsEscape(item.shop) +
		'</a></p>' +
		'<p class="simple-is__movie-badge simple-is__movie-badge--' +
		simpleIsRegion(item.pref) +
		'">' +
		simpleIsEscape(item.pref) +
		'</p>' +
		'</div>' +
		'<div class="simple-is__movie-staff anim fadeInUp">' +
		'<h3 class="simple-is__movie-ttl en-pd">STAFF</h3>' +
		'<ul class="simple-is__movie-staff-list">' +
		simpleIsStaffHtml(item.staff) +
		'</ul>' +
		'</div>' +
		'</li>'
	);
}

// 最終行の空きセル。PCで下端の破線を最後まで引くために入れる（SPはCSS側で非表示）
function simpleIsEmptyHtml(count) {
	var html = '';
	for (var i = 0; i < count; i++) {
		html += '<li class="simple-is__movie-card simple-is__movie-card--empty" aria-hidden="true"></li>';
	}
	return html;
}

// ----------------------------------------------------
//	動画カード — デバイスごとに再生UIを出し分ける
//
//	PC   : poster + 独自の再生ボタン → クリックでインライン再生。標準controlsで操作
//	スマホ: 独自ボタンは出さない（OSがposter上に標準の再生ボタンを自動表示するため）。
//	        縦動画なのでタップで全画面再生にする
//	        - iOS   : playsinline を外すと再生時に自動で全画面になる
//	        - Android: play時に requestFullscreen() を呼ぶ
//
//	判定は画面幅ではなくデバイス特性（hoverできない＝タッチ機）で行う。
//	共通: 再生中は他を止める（音が重ならないように）／ダウンロード導線は出さない
// ----------------------------------------------------
function simpleIsInitMovieUI() {
	var videos = Array.prototype.slice.call(document.querySelectorAll('.simple-is__movie-video video'));
	var isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

	videos.forEach(function (video) {
		var wrap = video.parentNode;
		var playBtn = wrap.querySelector('.simple-is__movie-play');

		if (isTouch) {
			// スマホは標準UIに委ねる。独自ボタンはDOMごと外して二重タップを防ぐ
			if (playBtn) {
				playBtn.parentNode.removeChild(playBtn);
			}
			// iOS: playsinline を外すと再生時に自動で全画面になる
			video.removeAttribute('playsinline');
		} else if (playBtn) {
			playBtn.addEventListener('click', function () {
				video.play();
			});
		}

		// 右クリック（長押し）の「動画を保存」を抑止
		video.addEventListener('contextmenu', function (e) {
			e.preventDefault();
		});

		video.addEventListener('play', function () {
			// GA計測: 再生された回数を店舗コードごとに送る（最後まで見なくても再生開始でカウント）
			var shop = (video.getAttribute('src') || '').match(/\/(\d+)\.mp4/);
			if (typeof gtag === 'function' && shop) {
				gtag('event', 'simple_is_movie_' + shop[1]);
			}

			// 再生が始まったら他を止める＝同時に鳴るのは常に1本だけ
			videos.forEach(function (other) {
				if (other !== video && !other.paused) {
					other.pause();
				}
			});

			// Android: 全画面にする（iOSは playsinline を外してあるので自動で全画面になる）
			if (isTouch && video.requestFullscreen) {
				video.requestFullscreen().catch(function () {
					// 全画面が拒否されてもインライン再生は続くので握りつぶす
				});
			}

			wrap.classList.add('is-playing');
		});

		video.addEventListener('pause', function () {
			wrap.classList.remove('is-playing');
		});

		video.addEventListener('ended', function () {
			wrap.classList.remove('is-playing');
		});
	});
}

// 絞り込みとページ番号はURLに載せる（例 ?area=tohoku&page=2）
// 既定値（全件・1ページ目）は付けずURLを短く保つ。リンク先を location.pathname にしておくと
// ローカルでも本番でも同じコードで正しく動く
function buildSimpleIsUrl(area, page) {
	var params = new URLSearchParams();
	if (area && area !== 'all') params.set('area', area);
	if (page && page > 1) params.set('page', page);
	var qs = params.toString();
	return location.pathname + (qs ? '?' + qs : '');
}

function getSimpleIsArea() {
	return new URLSearchParams(location.search).get('area') || 'all';
}

function getSimpleIsPage() {
	var p = parseInt(new URLSearchParams(location.search).get('page'), 10);
	return p > 0 ? p : 1;
}

function simpleIsPagerHtml(area, page, totalPages) {
	if (totalPages <= 1) return ''; // 1ページに収まるうちは出さない
	var btn = 'simple-is__movie-pager-btn';
	var html =
		page > 1
			? '<a class="' + btn + '" href="' + buildSimpleIsUrl(area, page - 1) + '">← PREV</a>'
			: '<span class="' + btn + ' ' + btn + '--disabled">← PREV</span>';
	for (var p = 1; p <= totalPages; p++) {
		html +=
			p === page
				? '<span class="' + btn + ' ' + btn + '--active">' + p + '</span>'
				: '<a class="' + btn + '" href="' + buildSimpleIsUrl(area, p) + '">' + p + '</a>';
	}
	html +=
		page < totalPages
			? '<a class="' + btn + '" href="' + buildSimpleIsUrl(area, page + 1) + '">NEXT →</a>'
			: '<span class="' + btn + ' ' + btn + '--disabled">NEXT →</span>';
	return html;
}

// 絞り込みボタンは「公開済みデータに実際にある地域」だけ出す（押しても0件のボタンを並べない）
// 並び順は SIMPLE_IS_REGIONS の定義順＝北から南
function simpleIsFilterHtml(published, area) {
	var found = {};
	published.forEach(function (item) {
		found[simpleIsRegion(item.pref)] = true;
	});
	var regions = Object.keys(SIMPLE_IS_REGIONS).filter(function (r) {
		return found[r];
	});
	if (regions.length <= 1) return ''; // 1地域しか無いうちは絞り込む意味が無い

	var btn = 'simple-is__movie-filter-btn';
	var html = '<button type="button" class="' + btn + (area === 'all' ? ' ' + btn + '--active' : '') + '" data-area="all">ALL</button>';
	regions.forEach(function (r) {
		html +=
			'<button type="button" class="' +
			btn +
			(area === r ? ' ' + btn + '--active' : '') +
			'" data-area="' +
			r +
			'">' +
			SIMPLE_IS_AREA_LABELS[r] +
			'</button>';
	});
	return html;
}

var simpleIsMovieList = document.querySelector('.simple-is__movie-list');
var simpleIsPagerEl = document.querySelector('.simple-is__movie-pager');
var simpleIsFilterEl = document.querySelector('.simple-is__movie-filter');

// 掲載順は公開日の新しい順。JSONは配信日順に書いてよい（並べ替えはここでやる）
function renderSimpleIs(items, area, page) {
	var published = items
		.filter(simpleIsReady)
		.filter(simpleIsPublished)
		.sort(function (a, b) {
			return String(b.publish || '').localeCompare(String(a.publish || ''));
		});

	// 絞り込みは「公開済み全件」に対して行う。表示中のページ内で絞ると他ページの地域が消えて見える
	var all = published.filter(function (item) {
		return simpleIsMatchArea(item, area);
	});

	var totalPages = Math.max(1, Math.ceil(all.length / SIMPLE_IS_PAGE_SIZE));
	if (page > totalPages) page = totalPages;
	if (page < 1) page = 1;

	var pageItems = all.slice((page - 1) * SIMPLE_IS_PAGE_SIZE, page * SIMPLE_IS_PAGE_SIZE);
	// 空セルは「そのページの枚数」で計算する（最終ページが半端でも下端の破線が切れない）
	var rest = (SIMPLE_IS_COLS - (pageItems.length % SIMPLE_IS_COLS)) % SIMPLE_IS_COLS;

	simpleIsMovieList.innerHTML = pageItems.map(simpleIsCardHtml).join('') + simpleIsEmptyHtml(rest);
	if (simpleIsPagerEl) simpleIsPagerEl.innerHTML = simpleIsPagerHtml(area, page, totalPages);
	// ボタンは絞り込み前の published から作る（絞った後だと他の地域ボタンが消えてしまう）
	if (simpleIsFilterEl) simpleIsFilterEl.innerHTML = simpleIsFilterHtml(published, area);

	simpleIsInitMovieUI(); // 描画後に呼ぶ（DOMContentLoaded ではカードがまだ無い）
	window.dispatchEvent(new Event('anim:refresh')); // 追加した .anim を control.js に拾わせる
}

// ページを切り替えたら1枚目のカードが先頭に来るようにする（固定ヘッダーの分だけ残す）
function simpleIsScrollToList() {
	var top = simpleIsMovieList.getBoundingClientRect().top + (window.scrollY || 0) - SIMPLE_IS_HEADER_OFFSET;
	window.scrollTo(0, Math.max(0, top));
}

if (simpleIsMovieList) {
	fetch(SIMPLE_IS_JSON)
		.then(function (res) {
			return res.json();
		})
		.then(function (items) {
			renderSimpleIs(items, getSimpleIsArea(), getSimpleIsPage());

			if (simpleIsFilterEl) {
				simpleIsFilterEl.addEventListener('click', function (e) {
					var btn = e.target.closest('.simple-is__movie-filter-btn');
					if (!btn) return;
					// 絞り込みを変えたら必ず1ページ目に戻す（3ページ目のまま絞ると空表示になる）
					var area = btn.getAttribute('data-area');
					history.pushState(null, '', buildSimpleIsUrl(area, 1));
					renderSimpleIs(items, area, 1);
				});
			}

			if (simpleIsPagerEl) {
				simpleIsPagerEl.addEventListener('click', function (e) {
					var link = e.target.closest('a.simple-is__movie-pager-btn');
					if (!link) return;
					// リロードせず描き替える（<a>のままにしてあるのは新規タブで開いたときのため）
					e.preventDefault();
					history.pushState(null, '', link.getAttribute('href'));
					renderSimpleIs(items, getSimpleIsArea(), getSimpleIsPage());
					simpleIsScrollToList();
				});
			}

			window.addEventListener('popstate', function () {
				renderSimpleIs(items, getSimpleIsArea(), getSimpleIsPage());
			});
		})
		.catch(function (err) {
			console.warn('simple_is load failed:', err);
		});
}

new Vue({
	el: '#style-section',
	data: {
		items: [],
		tag_label: '#' + SIMPLE_IS_TAG,
		more_href: 'https://www.dot-st.com/cp/sb-style/?tag=' + encodeURIComponent(SIMPLE_IS_TAG) + '&label=' + SIMPLE_IS_LABEL,
	},
	mounted: function () {
		var self = this;
		axios
			.get(SIMPLE_IS_API + '&count=' + SIMPLE_IS_COUNT + '&tag=' + encodeURIComponent(SIMPLE_IS_TAG) + '&label=' + SIMPLE_IS_LABEL)
			.then(function (response) {
				self.items = response.data.item;
			});
	},
});
